// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GiftBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27 8.5h-3.242c.463-.675.721-1.47.742-2.289A4.578 4.578 0 0 0 19.789 1.5a4.18 4.18 0 0 0-3.039 1.406A6.835 6.835 0 0 0 16 3.944a6.835 6.835 0 0 0-.75-1.038A4.18 4.18 0 0 0 12.211 1.5 4.577 4.577 0 0 0 7.5 6.211c.02.819.279 1.614.742 2.289H5A2.5 2.5 0 0 0 2.5 11v4a2.5 2.5 0 0 0 2 2.45V25A2.5 2.5 0 0 0 7 27.5h18a2.5 2.5 0 0 0 2.5-2.5v-7.55a2.5 2.5 0 0 0 2-2.45v-4A2.5 2.5 0 0 0 27 8.5Zm-.5 6h-9v-3h9v3ZM19 4.896a1.198 1.198 0 0 1 .875-.396h.044A1.577 1.577 0 0 1 21.5 6.125a1.198 1.198 0 0 1-.396.875c-.863.765-2.281 1.158-3.454 1.345.188-1.168.58-2.586 1.35-3.449Zm-8.037.067a1.6 1.6 0 0 1 1.113-.463h.049a1.199 1.199 0 0 1 .875.396c.765.863 1.158 2.28 1.344 3.452-1.163-.19-2.594-.582-3.448-1.348a1.197 1.197 0 0 1-.396-.875 1.59 1.59 0 0 1 .463-1.162ZM5.5 11.5h9v3h-9v-3Zm2 6h7v7h-7v-7Zm10 7v-7h7v7h-7Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
